import comp from "./DescriptorTable";
export default comp;
